if (!customElements.get('cm-bf-carousel')) {
  customElements.define('cm-bf-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.cm-bf-track');
      this.controls = this.querySelector('.cm-bf-carousel__controls');
      if (!this.track || !this.controls) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 4;
        this.controls.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 4;
        this.controls.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft > max - 4;
      };
      this.move = direction => this.track.scrollBy({
        left: direction * (this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap)),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button) this.move(Number(button.dataset.direction));
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target === this.track && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'instant'});
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.controller = null;
    }
  });
}
